export default __webpack_public_path__ + "static/media/deniz-kitapevi.249a9e34.jpg";